// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL Reports API (nestjs)
 * API for reports in WL
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface StudentVocabularyMonthResponseDto
 */
export interface StudentVocabularyMonthResponseDto {
  /**
   * The vocabulary word by the student
   * @type {string}
   * @memberof StudentVocabularyMonthResponseDto
   */
  word: string | null
  /**
   * Indicates whether the word is a misspelling or not
   * @type {boolean}
   * @memberof StudentVocabularyMonthResponseDto
   */
  isMisspelling: boolean | null
  /**
   * The number of times the word was used
   * @type {number}
   * @memberof StudentVocabularyMonthResponseDto
   */
  frequency: number | null
}

/**
 * Check if a given object implements the StudentVocabularyMonthResponseDto interface.
 */
export function instanceOfStudentVocabularyMonthResponseDto(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'word' in value
  isInstance = isInstance && 'isMisspelling' in value
  isInstance = isInstance && 'frequency' in value

  return isInstance
}

export function StudentVocabularyMonthResponseDtoFromJSON(
  json: any,
): StudentVocabularyMonthResponseDto {
  return StudentVocabularyMonthResponseDtoFromJSONTyped(json, false)
}

export function StudentVocabularyMonthResponseDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentVocabularyMonthResponseDto {
  if (json === undefined || json === null) {
    return json
  }
  return {
    word: json['word'],
    isMisspelling: json['isMisspelling'],
    frequency: json['frequency'],
  }
}

export function StudentVocabularyMonthResponseDtoToJSON(
  value?: StudentVocabularyMonthResponseDto | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    word: value.word,
    isMisspelling: value.isMisspelling,
    frequency: value.frequency,
  }
}
